export default __webpack_public_path__ + "static/media/loc_img_7.3784f496.jpg";